import { usePublisher, insertDirective$ } from '@mdxeditor/editor'
import IconButton from '@mui/material/IconButton'
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined'
import Tooltip from '@mui/material/Tooltip'
import useStore from 'reusable/mobx-store-utils'
import GapMindsetPluginStore from './GapMindsetPluginStore'
import { observer } from "mobx-react-lite"
import GapDialog from 'reusable/gap-dialog/GapDialog'
import MindsetImageTab from './MindsetImageTab'

export default observer(function GapMindsetPlugin() {
   const insertDirective = usePublisher(insertDirective$)

   const gapMindsetPluginStore = useStore(sp => new GapMindsetPluginStore(sp), {
      insertDirective
   })

   return <>
      <Tooltip title="Insert mindset">
         <IconButton size="small" onClick={gapMindsetPluginStore.modalState.open}>
            <PsychologyOutlinedIcon fontSize="small" />
         </IconButton>
      </Tooltip>

      <GapDialog modalState={gapMindsetPluginStore.modalState} size="small" title="Add mindset">
         <MindsetImageTab onAdd={gapMindsetPluginStore.insertMindsetImage} />
      </GapDialog>
   </>
})
